/**
 * Action types.
 * @module constants/ActionTypes
 */

export const POST_IMPORT = 'POST_IMPORT';
